import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StrategyFormComponent } from './strategy-form.component';
import { StrategySetupComponent } from './components/strategy-setup/strategy-setup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';

import { StrategyDefineComponent } from './components/strategy-define/strategy-define.component';
import { StrategyTakeEntryComponent } from './components/strategy-take-entry/strategy-take-entry.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { StrategyParamsFormComponent } from './components/strategy-params-form/strategy-params-form.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { StrategyTakeExitComponent } from './components/strategy-take-exit/strategy-take-exit.component';
import { NgSpinBoxModule } from '../../directives/ng-spin-box/ng-spin-box.module';
import { BasicIndicatorFormComponent } from './components/basic-indicator-form/basic-indicator-form.component';
import { AdvanceIndicatorFormComponent } from './components/advance-indicator-form/advance-indicator-form.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { RepairConditionComponent } from './components/repair-condition/repair-condition.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { InputRegexModule, PreventDefaultModule } from '@app/_shared/directives';
import { UnsortedKeyValueModule, PrecisionModule } from '@app/_shared/pipes';
import { NumberOnlyModule } from '@app/_shared/directives/number-only/number-only.module';
import { TextBuilderModeComponent } from './components/text-builder-mode/text-builder-mode.component';
import { polyfill as keyBoardEventKeyPolyfill } from 'keyboardevent-key-polyfill';
import { TextInputAutocompleteModule } from '../text-input-autocomplete';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { AdvanceSymbolSearchModule } from './components/advance-indicator-form/components/advance-symbol-search/advance-symbol-search.module';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';

keyBoardEventKeyPolyfill();
@NgModule({
    declarations: [
        StrategyFormComponent,
        StrategySetupComponent,
        StrategyDefineComponent,
        StrategyTakeEntryComponent,
        StrategyParamsFormComponent,
        StrategyTakeExitComponent,
        BasicIndicatorFormComponent,
        AdvanceIndicatorFormComponent,
        RepairConditionComponent,
        TextBuilderModeComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatButtonModule,
        MatDialogModule,
        NgSpinBoxModule,
        MatMenuModule,
        MatExpansionModule,
        MatListModule,
        MatCardModule,
        MatTooltipModule,
        InputRegexModule,
        UnsortedKeyValueModule,
        MatSelectModule,
        MatFormFieldModule,
        PrecisionModule,
        PreventDefaultModule,
        NumberOnlyModule,
        TextInputAutocompleteModule,
        MatProgressSpinnerModule,
        AdvanceSymbolSearchModule,
        MatTabsModule
    ],
    exports: [
        StrategyFormComponent
    ]
})
export class StrategyFormModule { }
